const { VIEW_VEHICLE_SUGGESTIONS, VIEW_VEHICLE_SUGGESTIONS_SUCCESS, VIEW_VEHICLE_SUGGESTIONS_FAIL, APPROVE_VEHICLE_SUGGESTIONS, APPROVE_VEHICLE_SUGGESTIONS_SUCCESS, APPROVE_VEHICLE_SUGGESTIONS_FAIL, REJECT_VEHICLE_SUGGESTIONS, REJECT_VEHICLE_SUGGESTIONS_SUCCESS, REJECT_VEHICLE_SUGGESTIONS_FAIL, ADD_VEHICLE, ADD_VEHICLE_SUCCESS, ADD_VEHICLE_FAIL, SEND_SUGGESTION_EMAIL, SEND_SUGGESTION_EMAIL_FAILED, SEND_SUGGESTION_EMAIL_SUCCESS, CHANGE_ACTION, CHANGE_ACTION_SUCCESS, CHANGE_ACTION_FAIL } = require("./Constants");

const initialState = {
    Loading: false,
    errors: "",
    successMsg: "",
    suggestionList: []
}

const VehicleMasterReducer = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_VEHICLE_SUGGESTIONS:
        case SEND_SUGGESTION_EMAIL:
        case APPROVE_VEHICLE_SUGGESTIONS:
        case REJECT_VEHICLE_SUGGESTIONS:
        case CHANGE_ACTION:
        case ADD_VEHICLE:
            return {
                ...state,
                Loading: true,
                errors: "",
                successMsg: ""
            }
        case VIEW_VEHICLE_SUGGESTIONS_SUCCESS:
            return {
                ...state,
                Loading: false,
                suggestionList: action.payload
            }

        case APPROVE_VEHICLE_SUGGESTIONS_SUCCESS:
        case SEND_SUGGESTION_EMAIL_SUCCESS:
        case REJECT_VEHICLE_SUGGESTIONS_SUCCESS:
        case CHANGE_ACTION_SUCCESS:
        case ADD_VEHICLE_SUCCESS:
            return {
                ...state,
                Loading: false,
                successMsg: action.payload
            }

        case VIEW_VEHICLE_SUGGESTIONS_FAIL:
        case SEND_SUGGESTION_EMAIL_FAILED:
        case APPROVE_VEHICLE_SUGGESTIONS_FAIL:
        case REJECT_VEHICLE_SUGGESTIONS_FAIL:
        case CHANGE_ACTION_FAIL:
        case ADD_VEHICLE_FAIL:
            return {
                ...state,
                Loading: false,
                errors: action.payload
            }
        default:
            return state;
    }
}

export default VehicleMasterReducer;